module.exports = __webpack_public_path__ + "img/gambrel.5ee0c6d5.jpg";